import {
  takeLatest, put, call,
} from 'redux-saga/effects'
import noop from 'lodash/noop'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import cookie from 'react-cookies'
import socketLogger from '@/helpers/loggers'
import {
  SOCKET_CONNECT,
  setSocketConnection,
} from '@/store/actions/socket'
import { requestGetIntegrations } from '@/store/actions/integrations/getIntegrations'
import { ACCESS_TOKEN_COOKIE } from '@/constants/names'
import { requestUserLogout } from '@/store/actions/user/logout'
import createNotifications from '@/helpers/notification'
import { selectSystem, setMode } from '@/store/actions/integrations'
import { refreshAccessToken, isRefreshRejected } from '@/helpers/axios/refreshAccessToken'

const connect = (client, token) => () => new Promise((resolve, reject) => {
  client.connect(
    { access_token: token },
    resolve,
    reject,
  )
})

function* connectWithToken(url, accessToken) {
  const socket = new SockJS(url)
  const client = Stomp.over(socket)

  if (process.env.REACT_APP_SOCKET_DEBUG === 'true') {
    client.debug = socketLogger
  } else {
    client.debug = noop
  }

  const connectAnswer = yield call(connect(client, accessToken))
  yield put(setSocketConnection(client))

  if (connectAnswer && accessToken) {
    yield put(requestGetIntegrations())
  }
}

function* connectToSocket({ payload }) {
  const {
    url,
    token,
    retriedAfterRefresh = false,
  } = payload

  try {
    const accessToken = token || cookie.load(ACCESS_TOKEN_COOKIE)

    if (!accessToken) {
      yield put(requestUserLogout())
      return
    }

    yield call(connectWithToken, url, accessToken)
  } catch (error) {
    if (!retriedAfterRefresh) {
      try {
        const data = yield call(refreshAccessToken)
        const newToken = data?.access_token || cookie.load(ACCESS_TOKEN_COOKIE)
        if (newToken) {
          try {
            yield call(connectWithToken, url, newToken)
            return
          } catch (connectAfterRefreshError) {
            console.log('connectToSocket after refresh failed', connectAfterRefreshError)
          }
        }
      } catch (refreshError) {
        if (isRefreshRejected(refreshError) || refreshError.isRefreshRejected) {
          yield put(requestUserLogout())
          return
        }
      }
    }

    const toast = createNotifications()
    console.log('function*connectToSocket -> error', error)
    toast({
      title: 'Ошибка подключения',
      description: 'Соединение прервано.\nНевозможно получить данные.\nПовторите попытку позже.',
      type: 'error',
    })
    yield put(selectSystem(null))
    yield put(setMode('CONNECTED_INTEGRATION'))
  }
}

export default function* root() {
  yield takeLatest(SOCKET_CONNECT, connectToSocket)
}
